
  export default {
    computed: {
      noQuotes () {
        return (this.search && this.search.no_quotes) ? this.search.no_quotes : null;
      },
      rejectReason () {
        return (this.search && this.search.reject_reason) ? this.search.reject_reason : '';
      },
      applyOfflineForm () {
        return (this.search && this.search.zurich_proposal_form) ? this.search.zurich_proposal_form : null;
      },
      search () {
        return this.$store.getters['search/get'];
      }
    }
  };
